import InfoDialog from "@/components/ui/InfoDialog";

export default function WarrantyDialog() {
  return (
    <InfoDialog
      title="SolarCloud Warranty Overview"
      triggerClassName="hover:text-brand-blue-300"
    >
      <p>
        At SolarCloud, we believe in providing comprehensive protection for your
        solar energy system. Our warranty coverage goes beyond just the lifespan
        of your solar panels. We include a complete suite of services to ensure
        your system operates at its best, just like a bumper-to-bumper warranty
        on your vehicle.
      </p>
      <p className="font-semibold">What Our Warranty Covers:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Every Component: From the smallest nut and bolt to the major
          components, our warranty ensures that every part of your solar system
          is covered.
        </li>
        <li>
          Inverter Replacement: Should your inverter require replacement, worry
          not! We've got you covered throughout the warranty period.
        </li>
        <li>
          Maintenance: Regular maintenance is critical to the longevity and
          efficiency of your system. Our warranty includes comprehensive
          maintenance services to keep your solar energy system running
          smoothly.
        </li>
        <li>
          Monitoring: We continuously monitor your system's performance to
          ensure it's generating energy efficiently. Any potential issues will
          be detected early, giving you peace of mind.
        </li>
        <li>
          Cleaning: We provide cleaning services for your solar panels, as a
          clean surface maximizes efficiency and energy output.
        </li>
      </ul>
      <p>
        With SolarCloud, you can rest assured that your solar investment is
        fully protected. Enjoy the confidence of complete coverage for the
        duration of your warranty, ensuring optimal performance for years to
        come. Welcome to a worry-free solar experience!
      </p>
    </InfoDialog>
  );
}
